// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3GSUf","inputWrap":"Table_inputWrap__3oPxr","col":"Table_col__1L_KZ","bmiTooltip":"Table_bmiTooltip__GaDQb"};